<template>
  <svg
    id="Calque_1"
    data-name="Calque 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1200 334.33"
  >
    <g>
      <path
        fill="currentColor"
        d="M254.7,138.84c0,16.44,13.32,29.76,29.76,29.76v-29.76h-29.76Z"
      />
      <path
        fill="currentColor"
        d="M314.21,124.51c0-8.52-6.91-15.43-15.43-15.43h-14.33v29.76h29.76v-14.33Z"
      />
      <rect
        fill="currentColor"
        x="284.46"
        y="168.6"
        width="29.76"
        height="29.76"
      />
      <rect
        fill="currentColor"
        x="224.94"
        y="109.08"
        width="29.76"
        height="29.76"
      />
      <polygon
        fill="currentColor"
        points="224.94 198.36 224.94 228.12 254.7 228.12 284.46 228.12 284.46 198.36 254.7 198.36 224.94 198.36"
      />
      <polygon
        fill="currentColor"
        points="224.94 138.84 195.18 138.84 195.18 168.6 195.18 198.36 224.94 198.36 224.94 168.6 224.94 138.84"
      />
    </g>
    <g>
      <path
        fill="currentColor"
        d="M383.88,178.45v-.94h20.3v.54c0,4.73,3.14,8.91,14.55,8.91,12.25,0,14.55-3.11,14.55-6.21,0-12.83-48.88,4.73-48.88-26.2,0-11.61,8.16-22.14,34.33-22.14,24.07,0,33.7,12.29,34.33,26.33h-20.3c-.31-4.46-3.56-8.51-14.03-8.51-11.72,0-14.02,2.97-14.02,5.94,0,12.29,48.88-5.13,48.88,25.79,0,12.42-7.95,22.82-34.85,22.82s-34.85-11.75-34.85-26.33Z"
      />
      <path
        fill="currentColor"
        d="M511.64,183.18c-2.61,1.75-6.68,3.24-13.58,3.24-9.94,0-15.8-4.46-17.9-11.07h54.53c.31-2.57.42-4.46.42-6.48,0-20.12-12.77-36.46-37.16-36.46s-37.05,16.34-37.05,36.19,12.66,36.19,36.84,36.19c21.57,0,31.57-12.02,35.31-21.61h-21.42ZM497.96,150.64c10.05,0,15.8,4.46,18,11.21h-35.9c2.2-6.75,7.95-11.21,17.9-11.21Z"
      />
      <path
        fill="currentColor"
        d="M624.17,168.33v-34.16h19.89v28.22c0,13.23,5.76,20.79,15.18,20.79s15.18-7.56,15.18-20.79v-28.22h19.89v68.73h-19.89l2.72-19.99h-1.28c-3.14,14.58-12.01,21.88-24.26,21.88-16.85,0-27.42-13.64-27.42-36.46Z"
      />
      <path
        fill="currentColor"
        d="M732.91,202.89l-29.41-67.92h8.06l23.13,55.23c1.26,2.84,1.88,5.54,1.88,7.56v.41h1.15v-.41c0-2.02.63-4.73,1.88-7.56l23.13-55.23h7.95l-29.31,67.92h-8.48Z"
      />
      <path
        fill="currentColor"
        d="M861.53,202.89v-67.92h7.01l-1.36,20.25h1.15c2.3-11.34,9.09-21.74,21.22-21.74,13.58,0,24.13,11.68,24.13,30v1.62h-6.8v-1.08c0-15.52-8.64-22.84-18.5-22.84-10.37,0-20.05,13.27-20.05,30.92v30.79h-6.8Z"
      />
      <path
        fill="currentColor"
        d="M927.05,113.64c0-3.38,1.99-5.94,5.34-5.94s5.23,2.57,5.23,5.94-1.99,6.08-5.23,6.08-5.34-2.57-5.34-6.08ZM928.94,202.89v-64.22h6.8v64.22h-6.8Z"
      />
      <path
        fill="currentColor"
        d="M962.69,202.89v-57.25h-13.98v-7.02h13.98v-5.81c0-16.74,7.34-26.6,21.01-26.6s21.12,9.86,21.12,24.3v.27h-6.8v-.54c0-10.26-3.77-17.01-14.32-17.01s-14.11,6.75-14.11,19.17v6.21h35.22v7.02h-35.22v57.25h-6.91Z"
      />
      <path
        fill="currentColor"
        d="M837.28,183.18c-3.01,6.22-10.05,14.18-25.35,14.18-16.85,0-26.38-10.53-27.74-24.57h61.96c.1-1.22.21-2.3.21-3.78,0-19.85-12.14-35.51-34.43-35.51s-34.54,15.53-34.54,35.65,12.04,35.24,34.43,35.24c20.08,0,29.28-11.69,32.53-21.2h-7.08ZM811.93,140.51c16.96,0,26.58,11.07,27.74,25.52h-55.58c1.15-14.72,10.68-25.52,27.84-25.52Z"
      />
      <path
        fill="currentColor"
        d="M595.03,175.94c-2.01,4.7-7.04,8.73-15.96,8.73-10.88,0-16.75-7.56-16.75-16.07s5.86-16.2,16.75-16.2c9.46,0,14.55,4.53,16.29,9.59h20.23c-2.33-17.36-15.81-29.57-36.52-29.57-23.97,0-36.63,16.34-36.63,36.19s12.66,36.19,36.63,36.19c20.37,0,33.75-11.93,36.4-28.85h-20.44Z"
      />
    </g>
  </svg>
</template>
